import * as _ from 'underscore';
import axios from "axios";

// import "bootstrap-select";



export default class NewsList {
    constructor() {
        console.log('%c👍🏼 News List yes', 'color: yellow');
        this.latestNewsList = document.querySelectorAll('.news--list');
    }
    init() {
        
        this.latestNewsList.forEach(newsList => {

            let loadMore = newsList.querySelector('.load-more');
            let newsTemplate = newsList.querySelector('.newsTemplate');
            let target = newsList.querySelector('.news-list');
            let  apiString = '/wp-json/movianto/v2/news'
            let paged = 2; // already got forst page of results

            if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
                apiString = '../api/news.json';
            }
            
            loadMore.addEventListener('click', () => {
                loadMoreNews();
                
            })

            function templateNews(article) {
                let template = _.template(newsTemplate.innerHTML);
                let compiledResult = template(article);
                target.insertAdjacentHTML( 'beforeend', compiledResult );;
            }
            
            function getPartners() {
                ajaxMethod();
            }
            
            function loadMoreNews() {
                ajaxMethod(false);
            }
            
        
            function ajaxMethod() {         
                axios.get(apiString, {
                    params: {
                        paged: paged
                    }
                })
                .then( (res) => {
                    res.data.articles.forEach( article => {
                        templateNews(article);
                       
                    })
                    
                    if(paged * 4 >= res.data.numPosts) {
                        loadMore.style.display = "none";
                    }
                    paged++;
                })
            }
        })
    }

    
    
    // ajaxMethod(clearResultsFlag = true) {
    //     // console.log('ajax method');
    //     // let $loading = $('.brick-partner-search__loading');
        
    //     // $loading.addClass('loading');
    
    //     axios.get(this.getParamsApiString())
    //     .then( (res) => {
    //         // if(clearResultsFlag) {
    //         //     clearResults();
    //         // }
    //         if(data['partners'].length){
    //             $.each(data['partners'], function(index, partner) {
    //                 let partnerTypes = ""; 
    
    //                 $.each(partner['partner-type'], function(index, partnerType) {
    //                     partnerTypes += partnerType['name'] + ", ";
    //                 });
    //                 partner['partnerTypes'] = partnerTypes.slice(0, -2);
    //                 //  console.log('hello', partner);
    //                 this.templatePartner(partner);
    
    //             })
    
    //             // console.log("partner cards", $('.col--partnerCard'));
    
    //             var time = 150;
    
    //             let partnerShowPromises = [];
                
    //             $('.col--partnerCard').each(function(){
    
    //                 let $this = $(this);
    //                 var time2 = 100;
                    
    //                 partnerShowPromises.push(new Promise(outerResolve => {
    //                     setTimeout( function(){ 
    //                         $this.removeClass('col--partnerCard--hidden');
    
                            
    //                         partnerShowPromises.push(new Promise(resolve => {
    //                             setTimeout( function(){ 
    //                                 $this.removeClass('col--partnerCard--invisible');
    //                                 resolve();
    //                             }, time2);
    //                         }));
    //                         time2 += 100;
    
    //                         outerResolve();
    //                     }, time);
    //                 }));
                    
    //                 time += 150;
    //             });
    
    //             Promise.all(partnerShowPromises).then(function() {
    //                 $loading.removeClass('loading');
    
    //                 if( $('input[name="paged"]').val() * 20 >= data['numPosts'] ) {
    //                     $('.row--brick-partner-search__loadmore-row').hide();
    //                 } else {
    //                     $('.row--brick-partner-search__loadmore-row').show();
    //                 }
    //             }); 
    //         } else {
    //             //show no results bit
    //             $('.brick-partner-search__noResults').show();
    //             $loading.removeClass('loading');
    //             // console.log('//show no results');
    //         }
    //     })
    //     .catch(function (error) {
    //         // handle error
    //         $('.brick-partner-search__noResults').show();
    //       })
    //       .then(function () {
    //         // always executed
    //         target.removeClass('loading');
    //       });;
    
        
    // }
    
    // clearResults() {
    //     hideNoResults();
    //     target.empty();
    // }
    
    // hideNoResults() {
    //     $('.brick-partner-search__noResults').hide();
    // }
    
    // delay(time) {
    //     return new Promise(resolve => setTimeout(resolve, time));
    // }
      
    
}

